import {AbsPoint} from 'scriptable-abstract';

interface PointState {
  x: number;
  y: number;
}

const _DEFAULT_STATE: PointState = {
  x: 0,
  y: 0,
};

export class MockPoint extends AbsPoint<PointState> {
  constructor(x: number = 0, y: number = 0) {
    super({
      x,
      y,
    });
  }

  get x(): number {
    return this.state.x;
  }

  set x(value: number) {
    this.setState({x: value});
  }

  get y(): number {
    return this.state.y;
  }

  set y(value: number) {
    this.setState({y: value});
  }
}
